import './AdminActions.css'

function Actions(props){
    return (
        <div className='action'>
            <h2>{props.action}</h2>
            <a href={props.url} className='btn btn-primary'>Click Here</a>
        </div>
    )
}

export default Actions;